import React, { use, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import CommonTable from '../Table/CommonTable';
import './AllAstrologers.css'
import { API_END_POINT, TOKEN } from '../../constant';
import axios from 'axios';
import bg from '../../assets/Chat/image.png'
import { ceil } from 'lodash';



function AllAstrologers() {

  const [loading, setLoading] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [btnName, setBtnName] = useState("Add");
  const [astrologerName, setAstrologerName] = useState('');
  const [astrologerBio, setAstrologerBio] = useState('');
  const [experience, setExperience] = useState('');
  const [minuteWiseRate, setMinuteWiseRate] = useState('');
  const [chatWiseMinuteRate, setChatWiseMinuteRate] = useState()
  const [languages, setLanguages] = useState([]);
  const [specializations, setSpecializations] = useState([1]);
  const [selectedFile, setSelectedFile] = useState('')
  const [imageId, setImageId] = useState(null)
  const [ischat, setIsChat] = useState(false)
  const [chatList, setChatList] = useState('')
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [timer, setTimer] = useState(240);
  const chatBoxRef = useRef(null);
  const [astrologerId, setAstrologerId] = useState(null);
  const [userId, setUserId] = useState(null)
  const [username, setUsername] = useState('')
  const [isOnline, setIsOnline] = useState({});
  const [isCallCompleted, setIsCallCompleted] = useState();
  const [showAstrologoerUpdateFrom, setShowAstrologoerUpdateFrom] = useState(false);
  const [password, setPassword] = useState('')
  const [mobileNo, setMobileNo] = useState()
  const [email, setEmail] = useState()
  const [gender, setGender] = useState('FEMALE')
  const [isCall, setIsCall] = useState(false)
  const [callList, setCallList] = useState('')  
  const [astrologers, setAstrologers] = useState();

  const specializationsList = [
    {
      id: 1,
      name: 'Vedic Astrology'
    },
    {
      id: 2,
      name: 'Vedic Jyotishi'
    },
    {
      id: 3,
      name: 'Hast Rekha'
    },
    {
      id: 4,
      name: 'Tarot Reading'
    },
    {
      id: 5,
      name: 'Horoscope Matching'
    },
    {
      id: 6,
      name: 'Vastu Shastra'
    },
    {
      id: 7,
      name: 'Numerology'
    }
  ];
  

  useEffect(() => {
    if (isChatOpen && timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);

      return () => clearInterval(countdown);
    } else if (timer === 0) {
      setIsChatOpen(false);
    }
  }, [isChatOpen, timer]);

  // useEffect(() => {
  //   if (chatBoxRef.current) {
  //     chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  //   }
  // }, [messages]);

  const handleFormSubmit = (e) => {
    e.preventDefault()
    if (!astrologerName || !astrologerBio || !languages || !minuteWiseRate || !experience || !imageId) {
      toast.error("please fill all details")
      return
    }
    setLoading(true)
    addAstrologer()
  }

  const handleAstrologerDelete = async (id) => {
    console.log("object", id)
    const deleteAstrologerUrl = `${API_END_POINT}astrologers/delete/${id}`
    const deleteAstrologerHeaders = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {

      const response = await fetch(deleteAstrologerUrl, { method: 'DELETE', headers: deleteAstrologerHeaders })

      if (!response.ok) {
        toast.error("failed to delete astrologer")
        return
      }
      const responseData = await response.json()
      toast.success("deleted astrologer successfully")
      getAstrologers();
    } catch (error) {
      console.log('handle astrologer delete --->>>', error)
    }
  }

  const handleMainImageUpload = async (e) => {
    e.preventDefault();
    setLoading(true)
    if (!selectedFile) {
      toast.error('No image selected! Please select an image.');
      setLoading(false)
      return
    }
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await fetch(`${API_END_POINT}fileAttachment/uploadImages`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
        },
        body: formData,
      });
      if (!response.ok) {
        toast.error('Failed to upload image');
      }
      const data = await response.json();
      console.log("object", data)
      console.log("this image link is ", data.data.fileId)
      toast.success('Image uploaded successfully!');
      setImageId(data.data.fileId)
      console.log("image id ", imageId)
    } catch (error) {
      toast.error('Error uploading image');
    }
    finally {
      setLoading(false)
    }
  };

  const addAstrologer = async () => {
    const addAstrologerUrl = `${API_END_POINT}astrologers/create`;
    const astrologerData = {
      formData: {
        astrologerName: astrologerName,
        astrologerBio: astrologerBio,
        experience: experience,
        minuteWiseRate: minuteWiseRate,
        chatMinuteWiseRating: chatWiseMinuteRate,
        languages: languages.map(language => language.id),
        specializations: [1],
        fileId: imageId,
        username: email,
        password: password,
        mobileNo: mobileNo,
        email: email,
        gender: gender,

      },
    };

    const addAstrologerHeader = {
      Authorization: `Bearer ${TOKEN}`,
      'Content-Type': 'application/json',
    };

    try {
      const response = await fetch(addAstrologerUrl, {
        method: 'POST',
        headers: addAstrologerHeader,
        body: JSON.stringify(astrologerData),
      });

      if (!response.ok) {
        toast.error("Failed to add astrologer")
        return;
      }

      const data = await response.json();
      console.log('Astrologer added successfully:', data);

      toast.success("Astrologer added successfully")

      setAstrologerBio('')
      setAstrologerName('')
      setLanguages(null)
      setExperience(0)
      setMinuteWiseRate(0)
      setShowForm(false)
      getAstrologers()

    } catch (error) {
      console.error('Error adding astrologer:', error);
    } finally {
      setLoading(false)
    }
  };

  const handleChatClick = async (astrologerId) => {
    setIsChat(prevState => !prevState)
    const getChatListUrl = `${API_END_POINT}astrologers/get-all-chats-userdata/${astrologerId}`
    const getChatListHeaders = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {

      const response = await fetch(getChatListUrl, { method: 'GET', headers: getChatListHeaders })

      if (!response.ok) {
        toast.error('failed to fetch chat list')
      }

      const responseData = await response.json()

      setChatList(responseData.data)
      console.log("the data chatlist", chatList)

    } catch (error) {
      console.log("error in handle chat click () ---->>>>")
    }

  }

  const handleCallClick = async (astrologerId) => {
    setIsCall(prevState => !prevState)
    const getCallListUrl = `${API_END_POINT}astro-user-call/get/${astrologerId}`
    const getCallListHeaders = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {

      const response = await fetch(getCallListUrl, { method: 'GET', headers: getCallListHeaders })

      if (!response.ok) {
        toast.error('failed to fetch chat list')
      }

      const responseData = await response.json()

      setCallList(responseData.data)
      console.log("the data chatlist", chatList)

    } catch (error) {
      console.log("error in handle chat click () ---->>>>")
    }

  }



  const handleAstrologerUpdate = (row) => {
    setAstrologerId(row.id)
    setAstrologerBio(row.astrologerBio)
    setAstrologerName(row.astrologerName)
    setMinuteWiseRate(row.minuteWiseRate)
    setChatWiseMinuteRate(row.chatMinuteWiseRating)
    setLanguages(row.languages)
    setEmail(row.email)  
    setGender(row.gender)
    setMobileNo(row.mobileNo)
    setPassword(row.password)
    // setSpecializations(row.specializations)
    setExperience(row.experience)


    setShowAstrologoerUpdateFrom(prevState => !prevState)
  }


  const updateAstrologer = async () => {
    setLoading(true)
    const updateAstrologerUrl = `${API_END_POINT}astrologers/update/${astrologerId}`
    const updateAstrologerData = {
      formData: {
        astrologerName: astrologerName,
        astrologerBio: astrologerBio,
        experience: experience,
        minuteWiseRate: minuteWiseRate,
        chatMinuteWiseRating: chatWiseMinuteRate,
        languages: languages.map(language => language.id),
        specializations: [1],
        fileId: imageId,
        username: email,
        password: password,
        mobileNo: mobileNo,
        email: email,
        gender: gender
      }
    }
    const updateAstrologerHeaders = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${TOKEN}`
    }
    try {
      const response = await fetch(updateAstrologerUrl, { method: 'PUT', headers: updateAstrologerHeaders, body: JSON.stringify(updateAstrologerData) })
      if (!response.ok) {
        toast.error("Failed to update astrologer")
        return;
      }
      const responseData = await response.json();
      toast.success("Astrologer updated successfully");
      setAstrologerId()
      setAstrologerBio()
      setAstrologerName()
      setMinuteWiseRate()
      setLanguages()
      // setSpecializations()
      setShowAstrologoerUpdateFrom(false)
      getAstrologers();
    } catch (error) {
      console.log("error while updating astrologer", error)
    } finally {
      setLoading(false)
    }
  }



  const handleSendMessage = async () => {
    await sendMessage();
    fetchMessages();
  };
  const sendMessage = async () => {
    if (!input.trim()) return;
    try {
      const response = await axios.post(
        `${API_END_POINT}astrologers/save-chat-astrologer`,
        {
          userId,
          astrologerId,
          message: input,
          isMessageSentByUser: false,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${TOKEN}`,
          },
        }
      );
      setInput("");
      if (response.status === 200) {
        console.log("success");
      } else {
        console.error("Error sending message:", response.data);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const fetchMessages = async () => {
    // setMessages([])
    try {
      const response = await axios.get(
        `${API_END_POINT}astrologers/get-chats-user/${astrologerId}/${userId}`,
        {
          headers: {
            Authorization:
              // "Bearer eyJhbGciOiJIUzI1NiJ9.eyJST0xFIjoiUk9MRV9VU0VSIiwiTE9HSU5fVFlQRSI6ImxvY2FsIiwiVVNFUk5BTUUiOiI4NDU5NzU3ODY1IiwiVVNFUl9JRCI6MTQyNiwic3ViIjoiMTQyNiIsImlhdCI6MTczODg0NDEwMywiZXhwIjoxODAxOTE2MTAzfQ.ctWo7-3Fv7e4tr6dt4ZtkrMRVLuxsB0l3lTQaWr9t08",
              `Bearer ${TOKEN}`,
          },
        }
      );

      if (response.status === 200) {
        const data = response.data.data;
        console.log("prenting data -> ", data);
        setMessages(data.reverse() || []);
        console.log("this is set message --- >>>", messages)
      } else {
        console.error("Failed to fetch messages");
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  // useEffect(() => { fetchMessages() }, [astrologerId])

  const handleStatusChange = async (id) => {
    setLoading(true)

    const updateStatusUrl = `${API_END_POINT}astrologers/updateCurrentStatus/${id}`
    const updateStatusHeader = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {

      const response = await fetch(updateStatusUrl, { method: 'PUT', headers: updateStatusHeader })

      if (!response.ok) {
        toast.error("failed to update status")
        return
      }
      toast.success("status changed successfully")
      const responseData = response.json();
      getAstrologers()

    } catch (error) {
      console.log("handle status change --->>>", error)

    } finally {
      setLoading(false)
    }

  };

  useEffect(() => {
    if (isChatOpen) {
      fetchMessages();
      const interval = setInterval(fetchMessages, 1000);
      return () => clearInterval(interval);
    }
  }, [isChatOpen])

  const getAstrologers = async () => {
    setLoading(true)
    const getAstrologersUrl = `${API_END_POINT}astrologers/list`
    const getAstrologersHeaders = {
      Authorization: `Bearer ${TOKEN}`
    }
    try {
      const response = await fetch(getAstrologersUrl, { method: 'GET', headers: getAstrologersHeaders })

      if (!response.ok) {
        toast.error("error while trying to get astrologers list")
      }
      const responseData = await response.json();

      setAstrologers(responseData.data)

    } catch (error) {
      console.log("api response error for getAstrologers()--->>>")
    }
    finally {
      setLoading(false)
    }
  }

  const chatListColumn = [
    {
      name: 'Sr. No.',
      cell: (row, index) => row.chatId,
    },
    {
      name: "Astrologer Name",
      cell: (row) => row?.username,
    },
    {
      name: 'Actions',
      cell: (row, index) => (
        <div className='flex align-center gap-10' >
          <button className='edit-btn' onClick={() => {
            setUserId(row.userId)
            setIsChatOpen(true)
            setUsername(row.username)
          }} >
            See Chat...
          </button>
        </div>
      ),
    },
    {
      name: 'Status',
      cell: (row) => (
        <div>
          {row.isChatCompleted ? <span style={{ color: 'green' }} >
            completed
          </span> : <span style={{ color: 'red' }} >
            In Progress....
          </span>}
        </div>
      ),
    },
    {
      name: "Last Message",
      cell: (row) => row?.timeStamp,
    },
  ]

  const callListColumn = [
    {
      name: "User Name",
      cell: (row) => row?.userName,
    },
    {
      name: "Gender",
      cell: (row) => row?.gender,
    }, {
      name: 'DOB',
      cell: (row) => row?.userDOB,
    },
    {
      name: 'Mobile No',
      cell: (row) => row?.userMobileNo,
    },
    {
      name: 'marital Status',
      cell: (row) => row?.maritalStatus,
    },
    {
      name : 'Call Time',
      cell : (row) => row?.callTime,
    },
    {
      name: 'Call Status',
      cell: (row, index) => {
        return (
          <div className="button r" id="button-1">
            <input type="checkbox" className="checkbox" checked={row.isCallCompleted}   />

            <div className="knobs"></div>
            <div className="layer"></div>
          </div>
        )

      }
    },

    // {
    //   name: "Call Request Time",
    //   cell: (row) => row?.timeStamp,
    // },

  ]

  const columns = [
    {
      name: 'Sr. No.',
      cell: (row, index) => row.id,
    },
    {
      name: "Astrologer Name",
      cell: (row) => row?.astrologerName,
    },
    {
      name: "Profile Image",
      cell: (row) => <img
        title='Click to see Image'
        src={`${API_END_POINT}${row?.profile[0]}`}
        width={"auto"}
        height={"70"}
        alt="Blog Image"
      />
    },
    {
      name: 'Actions',
      cell: (row, index) => (
        <div className='flex align-center gap-10' onClick={() => {
          // console.log("the astrologer name is", row.astrologerName)
          // setAstrologerName(row.astrologerName)
          // console.log("the astrologer Bio is", row.astrologerBio)
          // setAstrologerBio(row.astrologerBio)
          // setExperience(row.experience)
          // setMinuteWiseRate(row.minuteWiseRate)
          // setLanguages(row.languages)
          // setSpecializations(row.specializations)
          console.log("this is row ", row)
          handleAstrologerUpdate(row)
        }} >
          <button className='edit-btn'>
            <svg width="25" height="25" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="m7 17.011 4.413-.015 9.632-9.54c.378-.378.586-.88.586-1.414 0-.534-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.581v4.43ZM18.045 4.456l1.589 1.583-1.597 1.582-1.586-1.585 1.594-1.58ZM9 13.416l6.03-5.974 1.586 1.586L10.587 15 9 15.004v-1.589Z"></path>
              <path d="M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2Z"></path>
            </svg>
          </button>
          <button className='flex align-center delete-btn-icon' onClick={() => (handleAstrologerDelete(row.id))} >
            <svg width="25" height="25" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2v12ZM9 4h6v2H9V4ZM8 8h9v12H7V8h1Z"></path>
              <path d="M9 10h2v8H9v-8Zm4 0h2v8h-2v-8Z"></path>
            </svg>
          </button>
        </div>
      ),
    },
    {
      name: "Status",
      cell: (row, index) => {
        isOnline[row?.id] = row?.currentStatus
        // console.log(isChecked[row?.id], 'and', row?.active)
        return (
          <div className="button r" id="button-1">
            <input type="checkbox" className="checkbox" checked={isOnline[row?.id]} onChange={(e) => (handleStatusChange(row?.id))} />

            <div className="knobs"></div>
            <div className="layer"></div>
          </div>
        )

      }
    },
    {
      name: 'Actions',
      cell: (row, index) => (
        <div className='flex align-center gap-10' >
          <button className='edit-btn' onClick={() => {
            console.log("object", row.id)
            setAstrologerId(row.id)
            handleChatClick(row.id)
          }}>
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="#AE285D"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.862 9.862 0 0 1-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8Z"></path>
            </svg>
          </button>
          <button className='flex align-center delete-btn-icon' onClick={() => {
            console.log("object", row.id)
            setAstrologerId(row.id)
            handleCallClick(row.id)
          }}>
            <svg
              width="24"
              height="24"
              fill="#AE285D"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.9 13.9 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.9 13.9 0 0 0 4 1.205c.139.02.322.042.55.064a.5.5 0 0 1 .449.498H21Z"></path>
            </svg>
          </button>
        </div>
      ),
    }

  ]

  const addRow = () => {
    // setBlogName('')
    // setContent('')
    setAstrologerName();
    setAstrologerBio()
    setLanguages()
    setMinuteWiseRate()
    setExperience()
    setLanguages()
    if (btnName === "Save") {
      setBtnName("Add");
    }
    setShowForm(!showForm);
  };

  useEffect(() => {
    console.log("useEffet getAstrologers()--->>")
    getAstrologers();
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      toast.error("No file selected");
    }
  };

  const isLanguageIdExist = (id) => {
    if (!languages || !languages.length) {
      return false;
    }
    return languages.some((lang) => lang.id === id);
  };

  //   const handleCheckbox = (e) => {
  //     const value = parseInt(e.target.value);
  //     setLanguages((prevLanguages) => {
  //         // Ensure prevLanguages is an array
  //         const languagesArray = prevLanguages || [];

  //         if (e.target.checked) {
  //             // Add the language if not already present
  //             if (!languagesArray.some((lang) => lang.id === value)) {
  //                 return [...languagesArray, { id: value }];
  //             }
  //             return languagesArray;
  //         } else {
  //             // Remove the language if present
  //             return languagesArray.filter((lang) => lang.id !== value);
  //         }
  //     });
  // };
  const handleCheckbox = (e) => {
    console.log("this is the handle checkox function")
    // e.preventDefault();
    const value = parseInt(e.target.value);
    setLanguages((prevLanguages) => {
      const languagesArray = prevLanguages || [];

      if (e.target.checked) {
        // Add the language if not already present
        if (!languagesArray.some((lang) => lang.id === value)) {
          return [...languagesArray, { id: value }];
        }
        return languagesArray;
      } else {
        return languagesArray.filter((lang) => lang.id !== value);
      }
    });
  };



  // function isLanguageIdExist(id) {
  //   if (!languages || !languages.length) {
  //     console.error("Languages array is undefined or empty");
  //     return false; 
  //   }


  //   // Find the language object by matching the id
  //   const languageCheck = languages.find(language => language.id === id);

  //   // Return true if the language with the given id is found, otherwise false
  //   return languageCheck !== undefined;
  // }

  //   const handleCheckbox = (e) => {
  //     const value = parseInt(e.target.value);
  //     console.log("Checkbox changed. Value:", value);

  //     setLanguages((prevLanguages) => {
  //         if (e.target.checked) {
  //             if (!prevLanguages.includes(value)) {
  //                 const updatedLanguages = [...new Set([...prevLanguages, value])];
  //                 console.log("Language added:", updatedLanguages);
  //                 return updatedLanguages;
  //             } else {
  //                 console.log("Language already selected:", prevLanguages);
  //                 return prevLanguages;
  //             }
  //         } else {
  //             const updatedLanguages = prevLanguages.filter((lang) => lang !== value);
  //             console.log("Language removed:", updatedLanguages);
  //             return updatedLanguages;
  //         }
  //     });
  // };

  const calculateModalSize = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    let modalWidth = Math.min(screenWidth * 0.8, 500); // 80% of screen width, max 500px
    let modalHeight = Math.min(screenHeight * 0.8, 600); // 80% of screen height, max 600px

    return { width: modalWidth, height: modalHeight };
  };

  const modalSize = calculateModalSize();



  return (
    <main className='main'>
      <h3>Astrologers</h3>
      {!loading ? (
        <div>
          <div style={{ marginTop: "10px" }} className='flex align-center justify-end'>
            <button onClick={addRow} className='common-btn flex align-center'>
              {!showForm ? "Add Astrologer" : "Cancel"}
            </button>
          </div>
          {showForm && (
            <form className='form'> 
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Name <span style={{fontSize : '13px',  opacity : '60%' , color : 'red' }} >  *minumum 3 characters</span> </label>
                <input
                  id='blogName'
                  type="text"
                  name="blogName"
                  value={astrologerName}
                  onChange={(e) => (setAstrologerName(e.target.value))}
                  placeholder="Enter Astrologer Name"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Email</label>
                <input
                  id='blogName'
                  type="email"
                  name="blogName"
                  value={email}
                  onChange={(e) => (setEmail(e.target.value))}
                  placeholder="Enter Astrologer Name"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Bio</label>
                <input
                  id='blogName'
                  type="text"
                  name="blogName"
                  value={astrologerBio}
                  onChange={(e) => (setAstrologerBio(e.target.value))}
                  placeholder="Enter Astrologer Bio"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="gender">Gender</label>
                <div className='gender-select'>
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="gender"
                      value="MALE"
                      checked={gender === 'MALE'}
                      onChange={(e) => setGender(e.target.value)}  
                      required
                    />
                    Male
                  </label>
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="gender"
                      value="FEMALE"
                      checked={gender === 'FEMALE'}
                      onChange={(e) => setGender(e.target.value)}
                      required
                    />
                    Female
                  </label>
                </div>
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Mobile No</label>
                <input
                  id='blogName'
                  type="number"
                  name="blogName"
                  value={mobileNo}
                  onChange={(e) => (setMobileNo(e.target.value))}
                  placeholder="Enter Mobile No "
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Password <span style={{fontSize : '13px',  opacity : '60%' , color : 'red' }} >  * minumum 8 characters</span> </label>
                <input
                  id='blogName'
                  type="password"
                  name="blogName"
                  value={password}
                  onChange={(e) => (setPassword(e.target.value))}
                  placeholder="Enter Astrologer Password"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Languages</label></div>
              <div className='languageSelect' >
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'1'} onClick={handleCheckbox} className="checkbox-input" />
                  English
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'2'} onClick={handleCheckbox} className="checkbox-input" />
                  Hindi
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'3'} onClick={handleCheckbox} className="checkbox-input" />
                  Marathi
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'4'} onClick={handleCheckbox} className="checkbox-input" />
                  Gujarati
                </label>
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="minuteWiseRate">Astrologer Call Charges per Minute (in Rs)</label>
                <input
                  type="number"
                  id="minuteWiseRate"
                  value={minuteWiseRate}
                  onChange={(e) => setMinuteWiseRate(e.target.value)}
                />
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="minuteWiseRate">Astrologer Chat Charges per Minute (in Rs)</label>
                <input
                  type="number"
                  id="minuteWiseRate"
                  value={chatWiseMinuteRate}
                  onChange={(e) => setChatWiseMinuteRate(e.target.value)}
                />
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="experience">Experience (in Years)</label>
                <input
                  type="number"
                  id="experience"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Main Astrologer Image</label>
                <input type="file" name="" onChange={handleImageUpload} id="fileupload" />
                <button style={{ width: 'fit-content' }} className='common-btn flex align-center' onClick={handleMainImageUpload}>
                  Add Main Image
                </button>
              </div>
              <div className='buttons flex flex-col'>
                <button type="submit" onClick={handleFormSubmit} className='btn'>{btnName}</button>
              </div>
            </form>
          )}

          {showAstrologoerUpdateFrom && (
            <form className='form'>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Name <span style={{fontSize : '13px',  opacity : '60%' , color : 'red' }} >  * minumum 3 characters</span> </label>
                <input
                  id='blogName' 
                  type="text"
                  name="blogName"
                  value={astrologerName}
                  onChange={(e) => (setAstrologerName(e.target.value))}
                  placeholder="Enter Astrologer Name"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Bio</label>
                <input
                  id='blogName'
                  type="text"
                  name="blogName"
                  value={astrologerBio}
                  onChange={(e) => (setAstrologerBio(e.target.value))}
                  placeholder="Enter Astrologer Bio"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Email</label>
                <input
                  id='blogName'
                  type="email"
                  name="blogName"
                  value={email}
                  onChange={(e) => (setEmail(e.target.value))}
                  placeholder="Enter Astrologer Name"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="gender">Gender</label>
                <div className='gender-select'>
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="gender"
                      value="MALE"
                      checked={gender === 'MALE'}
                      onChange={(e) => setGender(e.target.value)}  // Updates the gender state to "Male"
                      required
                    />
                    Male
                  </label>
                  <label className="custom-radio">
                    <input
                      type="radio"
                      name="gender"
                      value="FEMALE"
                      checked={gender === 'FEMALE'}
                      onChange={(e) => setGender(e.target.value)}
                      required
                    />
                    Female
                  </label>
                </div>
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Mobile No</label>
                <input
                  id='blogName'
                  type="number"
                  name="blogName"
                  value={mobileNo}
                  onChange={(e) => (setMobileNo(e.target.value))}
                  placeholder="Enter Mobile No "
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Password <span style={{fontSize : '13px',  opacity : '60%' , color : 'red' }} >  * minumum 8 characters</span> </label>
                <input
                  id='blogName'
                  type="password"
                  name="blogName"
                  value={password}
                  onChange={(e) => (setPassword(e.target.value))}
                  placeholder="Enter Astrologer Password"
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Astrologer Languages</label></div>
              <div className='languageSelect' >
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'1'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(1)} />
                  English
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'2'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(2)} />
                  Hindi
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'3'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(3)} />
                  Marathi
                </label>
                <label className="custom-checkbox">
                  <input type="checkbox" name="Fast and Festival" value={'4'} onClick={handleCheckbox} className="checkbox-input" defaultChecked={isLanguageIdExist(4)} />
                  Gujarati
                </label>
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="minuteWiseRate">Astrologer Charges per Minute (in Rs)</label>
                <input
                  type="number"
                  id="minuteWiseRate"
                  value={minuteWiseRate}
                  onChange={(e) => setMinuteWiseRate(e.target.value)}
                />
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="minuteWiseRate">Astrologer Chat Charges per Minute (in Rs)</label>
                <input
                  type="number"
                  id="minuteWiseRate"
                  value={chatWiseMinuteRate}
                  onChange={(e) => setChatWiseMinuteRate(e.target.value)}
                />
              </div>
              <div className='minutesinputfield'>
                <label htmlFor="experience">Experience (in Years)</label>
                <input
                  type="number"
                  id="experience"
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                />
              </div>
              <div className='input-field flex flex-col'>
                <label htmlFor="blogName">Main Webblog Image</label>
                <input type="file" name="" onChange={handleImageUpload} id="fileupload" />
                <button style={{ width: 'fit-content' }} className='common-btn flex align-center' onClick={handleMainImageUpload}>
                  Add Main Image
                </button>
              </div>
              <div className='buttons flex flex-col'>
                <button type="submit" onClick={updateAstrologer} className='btn'>Update</button>
              </div>
            </form>
          )}
          <div style={{ marginTop: "10px" }} onClick={(e) => { console.log("object", e.target) }} >
            <CommonTable columns={columns} data={astrologers} />
          </div>
          {ischat && (
            <div>
              <div style={{ marginTop: "10px" }} className='flex align-center justify-start'>
                <button onClick={() => {
                  setIsChat(prevState => !prevState)
                }} className='common-btn flex align-center'>
                  Close Chat List
                </button>
              </div>
              <div style={{ marginTop: "10px" }} onClick={(e) => { console.log("object", e.target) }} >
                <CommonTable columns={chatListColumn} data={chatList} />
              </div>
              <div className="container">
                {isChatOpen && (
                  <>
                    {/* <div
                      className="modal-overlay"
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        zIndex: 1040,
                      }}
                    ></div> */}

                    <div
                      className="modal-overlay"
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        zIndex: 1040,
                        display: isChatOpen ? 'block' : 'none'
                      }}
                      onClick={() => setIsChatOpen(false)}
                    >
                      <div
                        className="modal"
                        style={{
                          position: "fixed",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          display: "block",
                          zIndex: 1050,
                          width: modalSize.width,
                          height: modalSize.height,
                          border:'10px solid white',
                        }}
                        onClick={(e) => e.stopPropagation()}
                      > 
                        <div className="modal-dialog" style={{ height: '100%'  }}>
                          <div className="modal-content" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                            <div
                              className="modal-header"
                              style={{
                                backgroundColor: "#f8f9fa",
                                display: "flex",
                                alignItems: "center", // Vertically align items
                                justifyContent: "space-between", // Distribute space between items
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", padding: '5px' }}> {/* Container for left side */}
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                  alt="Astrologer"
                                  width="30"
                                  style={{ marginRight: "0.5rem" }}
                                />
                                <h5 className="modal-title" style={{ margin: 0 }}> {/* Remove default margin */}
                                  chat with {username}
                                </h5>
                              </div>
                              <button
                                type="button"
                                className="btn-close"
                                style={{
                                  boxShadow: "none",
                                  border: "none",
                                  marginRight: '10px',
                                  background: 'transparent'
                                  // padding : '10px'
                                  // Add any other styles for the close button here
                                }}
                                onClick={() => {
                                  console.log("message chat", messages)
                                  setIsChatOpen(false)
                                }}
                              ><svg width="26" height="26" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">   <path fill-rule="evenodd" d="M5.152 5.152a1.2 1.2 0 0 1 1.696 0L12 10.303l5.152-5.151a1.2 1.2 0 1 1 1.696 1.696L13.697 12l5.151 5.152a1.2 1.2 0 0 1-1.696 1.696L12 13.697l-5.152 5.151a1.2 1.2 0 0 1-1.696-1.696L10.303 12 5.152 6.848a1.2 1.2 0 0 1 0-1.696Z" clip-rule="evenodd"></path> </svg>

                              </button>
                            </div>


                            <div
                              className="modal-body chat-box"
                              ref={chatBoxRef}
                              style={{
                                flex: 1,
                                overflowY: "auto",
                                backgroundImage: `url(${bg})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                padding: "10px",
                                borderRadius: "5px",
                              }}
                            >
                              {messages.map((msg, index) => (
                                <div key={index} style={{ marginBottom: "1rem" }}>
                                  {msg.isMessageSentByUser === true ? (
                                    <div
                                      className="message-left"
                                      style={{
                                        textAlign: "left",
                                        maxWidth: "70%", // Increased max width
                                        background: "rgba(255, 255, 255, 0.8)",
                                        padding: "0.5rem",
                                        borderRadius: "5px",
                                        color: "#212529",
                                      }}
                                    >
                                      <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                                        {msg?.astrologerName}
                                      </pre>
                                      <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                                        {msg.message}
                                      </pre>
                                      <small className="text-muted d-block mt-1">
                                        {msg.timeStamp}
                                      </small>
                                    </div>
                                  ) : (
                                    <div
                                      className="message-right"
                                      style={{
                                        maxWidth: "70%", // Increased max width
                                        background: "#d8fdd1",
                                        textAlign: "right",
                                        marginLeft: "auto",
                                        padding: "0.5rem",
                                        borderRadius: "5px",
                                      }}
                                    >
                                      <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                                        {/* {msg.username} */} {/* If you want to display username */}
                                      </pre>
                                      <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                                        {msg.message}
                                      </pre>
                                      <small className="text-muted d-block mt-1">
                                        {msg.timeStamp}
                                      </small>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
{/* 
                            <div
                              className="chat-input"
                              style={{
                                padding: "1rem 0.5rem",
                                backgroundColor: "#fff",
                                display: "flex",
                                alignItems: "center",
                                flexWrap: 'wrap'
                              }}
                            >
                              <input
                                type="text"
                                className="form-control"
                                style={{
                                  marginRight: "1rem",
                                  borderRadius: "2.5rem",
                                  padding: "0.5rem 1rem",
                                  width: '100%'
                                }}
                                placeholder="Type your message here..."
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleSendMessage();
                                  }
                                }}
                              />
                              <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                <button
                                  onClick={() => {
                                    handleSendMessage();
                                  }}
                                  style={{
                                    fontSize: "12px",
                                    backgroundColor: "#ff6f00",
                                    color: "#fff",
                                    padding: "0.5rem 1rem",
                                    border: "none",
                                    borderRadius: "5px",
                                    marginTop: '15px',
                                    justifyContent: 'center'
                                  }}
                                >
                                  Send
                                </button>
                              </div>
                            </div> */}
{/* 
                            <div
                              className="call-info"
                              style={{
                                padding: "0.5rem",
                                backgroundColor: "#28a745",
                                color: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5rem",
                              }}
                            >
                              <span style={{ textAlign: "center" }}>
                                Remaining Time: {Math.floor(timer / 60)}:
                                {String(timer % 60).padStart(2, "0")}
                              </span>
                              <button
                                className="end-call"
                                style={{
                                  padding: "0.5rem 1rem",
                                  border: "none",
                                  borderRadius: "5px",
                                }}
                                onClick={() => {  }}
                              >
                                End Call
                              </button>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {isCall && (
            <div>
              <div style={{ marginTop: "10px" }} className='flex align-center justify-start'>
                <button onClick={() => {
                  setIsCall(prevState => !prevState)
                }} className='common-btn flex align-center'>
                  Close Call List
                </button>
              </div>
              <div style={{ marginTop: "10px" }} onClick={(e) => { console.log("object", e.target) }} >
                <CommonTable columns={callListColumn} data={callList} />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          <Loader />
        </div>
      )}
    </main>
  )
}

export default AllAstrologers
